import { render, staticRenderFns } from "./CreateContactBrain.vue?vue&type=template&id=4ee24df6&scoped=true"
import script from "./CreateContactBrain.vue?vue&type=script&lang=js"
export * from "./CreateContactBrain.vue?vue&type=script&lang=js"
import style0 from "./CreateContactBrain.vue?vue&type=style&index=0&id=4ee24df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee24df6",
  null
  
)

export default component.exports